"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import Honeybadger from "@honeybadger-io/js";
export default class ErrorBoundary extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", { hasError: false });
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.hasError && this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }
  componentDidCatch(error, info) {
    Honeybadger.notify(error, {
      context: {
        errorBoundary: this.props.name,
        componentStack: info.componentStack
      }
    });
  }
  render() {
    if (this.state.hasError) {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: "alert-box alert-box--caution centered",
          role: "alert",
          "data-component": "ErrorBoundary",
          children: [
            "Something went wrong displaying this section. ",
            /* @__PURE__ */ jsx("a", { href: "", children: "Reload" }),
            " to try again."
          ]
        }
      );
    }
    return this.props.children;
  }
}
